export const ICONS = {
  CHECKBOX_NOT_FILLED:
    "https://b.zmtcdn.com/data/o2_assets/981c5547da8c916d727ef343acebd9c01738240585.png",
  CHECKBOX_FILLED:
    "https://b.zmtcdn.com/data/o2_assets/d4708d65bdc9fbb79da8a514ca33f7c81738240639.png",
};
